module.exports = __webpack_public_path__ + "static/media/leader_notes_detailed.ee57ccbc.pdf";